<div>
  <div *ngIf="!!notification.data.inviterId && !!inviterName">
    <!-- <a class="id37-link" (click)="goToUserProfile()">{{inviterName}}</a> -->
    <span>{{inviterName}}</span>
    <span>{{messageInvitedBy}}</span>
  </div>
  <div>{{messagePartA}}</div>
</div>
